module.exports = __webpack_public_path__ + "img/Rastislav.0a5ac002.jpeg";